module.exports = __webpack_public_path__ + "img/levelmakeroptions.1bd9ec16.png";